
import api from 'api';
import AppUtils from 'lib/AppUtils';
import ManageSession from 'lib/ManageSession';

export const types = {
  LOG_IN: 'app/session/LOG_IN',
  LOG_OUT: 'app/session/LOG_OUT',
  LOG_IN_SUCCESSFUL: 'app/session/LOG_IN_SUCCESSFUL',
};

function login() {
  return {
    type: types.LOG_IN,
    payload: {},
  };
};

function logout() {
  AppUtils.logout();

  return {
    type: types.LOG_OUT,
    payload: { loginVerified: false },
  };
}

function loginSuccessful(sessionToken) {
  ManageSession.start(sessionToken);

  return {
    type: types.LOG_IN_SUCCESSFUL,
    payload: {
      sessionToken,
    },
  };
}

const actions = {
  login,
  logout,
  loginSuccessful,
};

export default actions;
